
import { Modal } from 'react-bootstrap';
import { formatDateTime } from '../orders/OrderComponent';
import { MessageApi } from '../../app/api/message.api';
import { useState } from 'react';

export function GeneralityHeader ({ active }) 
{
  return (  

    <div className="border bg-white text-secondary rounded-3 my-4">
      <div className="d-flex justify-content-between flex-column flex-md-row align-items-center border-bottom px-4 py-3 fs-5 gap-3">
        <span> <i className="bi bi-grid-fill me-2"></i> Généralité  </span>
      </div>  
      <div className="d-flex flex-column">
        <nav className="navbar navbar-expand-sm">
          <div className="container-fluid">
            <button className="navbar-toggler small" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav2" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon small"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav2">
              <ul className="navbar-nav my-2 px-3 gap-3">
                <li>
                  <a className={`btn btn-sm rounded-0 px-3 ${(active===1) ? 'btn-green' : 'btn-outline-green'}`} href="/generalite"> Messages </a>
                </li>
                <li>
                  <a className={`btn btn-sm rounded-0 px-3 ${(active===2) ? 'btn-green' : 'btn-outline-green'}`} href="/newsletters"> Newsletters </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
       </div> 
     </div>
  );
        
}



export function MessageViewModal({ show, onHide, message })
{

    return(
      <Modal show={show} onHide={onHide} centered size="lg">
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="text-green fs-5 ps-4">
            <i className="bi bi-envelope-open me-2"></i>
            Message
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="row justify-content-center p-4">
          <div className="message-content col-md-11">
            <div className="bg-light py-3 border-bottom mb-3">
              <div className="d-flex align-items-center gap-3 mb-1">
                <span className="text-muted fw-bold">De :</span>
                <span className="text-secondary">{ message?.email }</span>
              </div>
              <div className="d-flex align-items-center gap-3">
                <span className="text-muted small">Date d'émission :</span>
                <span className="text-secondary small">{ formatDateTime( message?.createdAt ) }</span>
              </div>
            </div>
            <div className="d-flex align-items-center gap-3 mb-2 border-bottom pb-3">
              <span className="text-muted fw-bold">Objet :</span>
              <span className="text-secondary fw-bold">{ message?.object }</span>
            </div>
            
            <div className="mb-3">
              <p className="text-muted small mb-2">Contenu du message :</p>
              <div style={{ maxHeight: '250px', overflowY: 'auto', backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', border: '1px solid #dee2e6' }}>
                <p className="text-secondary">{ message?.content }</p>
              </div>
            </div>

            <div className="mb-1">
              {
                message.isReplied && (
                   <div className="d-flex align-items-center gap-3 mb-2">
                     <span className="small text-green"> <i className="bi bi-check-circle me-1"></i> Répondu par :</span>
                     <span className="small text-green">{ message?.admin }</span>
                   </div>
                )
              }
            </div>

          </div>
        </Modal.Body>
        <Modal.Footer className="border-top gap-2">
          <button className="btn btn-sm btn-green me-3 px-3" onClick={onHide}>  Fermer </button>
        </Modal.Footer>
      </Modal>
    )
}



export function ConfirmResponseModal({ show, onHide, messageItem, refetch })
{

    const messages = MessageApi();
  
    const [status, setStatus] = useState(0);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false); 
  
  
    const handleConfirm = async ()=>{
  
      setStatus(0);
      setIsLoading(true);
  
      try {
          const {data} = await messages.update( messageItem?.id );
          if( data.success ){
              setStatus(1);
              setMessage(data.message);
              refetch();
          }
          else{
              setStatus(-1);
              setMessage('Erreur ! veuillez réessayer');
          }
      } catch (err) { 
          
          setStatus(-1);
          setMessage(err?.response?.data.message);
      } finally{
          setIsLoading(false);
      }
    }
  

    return(
      <Modal show={show} onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="text-green fs-5">
            <i className="bi bi-check-circle-fill text-green me-2"></i>
            Confirmation de réponse
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4">
          <div className="text-center">
            <i className="bi bi-chat-left-check text-green" style={{ fontSize: '3rem' }}></i>
            <p className="mt-3 text-secondary">
              Confirmez-vous que vous avez répondu à ce message ?
            </p>
            <p className="lead text-muted">
              <strong>Objet :</strong> { messageItem?.object }
            </p>
            {
              isLoading && (
                <div className="d-flex justify-content-center mb-2"> 
                  <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                </div>
              )
            }
            {
              status === 1 && (
                <div className="alert alert-success mb-2 small w-100"> { message } </div>
              )
            }
            {
              status === -1 && (
                <div className="alert alert-danger mb-2 small w-100"> { message } </div>
              )
            }
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top gap-2">
          <button className="btn btn-sm btn-outline-danger" onClick={onHide}>  Annuler </button>
          <button className="btn btn-sm btn-green" onClick={ handleConfirm }>
            <i className="bi bi-check-circle me-2"></i>
            Confirmer
          </button>
        </Modal.Footer>
      </Modal>
    )
}


export function LoaderModal({ show, message = 'Chargement...' })
{
    return(
      <Modal show={show} centered backdrop="static" keyboard={false}>
        <Modal.Body className="py-5">
          <div className="text-center">
            <div className="spinner-border text-green mb-3" style={{ width: '80px', height: '80px' }} role="status">
              <span className="visually-hidden">Chargement...</span>
            </div>
            <p className="text-secondary mt-3">{ message }</p>
          </div>
        </Modal.Body>
      </Modal>
    )
}



